import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from "@/shared/components/ui/card";
import { Delivery } from "@/services/backend/deliveries/delivery/delivery";
import { SampleSetTable } from "./sample-set-table";

interface PackageContentsProps {
  delivery: Delivery;
}

export default function PackageContents({ delivery }: PackageContentsProps) {
  return (
    <Card className="w-full shadow-none">
      <CardHeader className="flex items-start">
        <CardTitle className="text-2xl">Inhalt der Lieferung</CardTitle>
      </CardHeader>
      <CardContent className="flex w-full flex-col space-y-2">
        <SampleSetTable deliveryId={delivery.id} />
      </CardContent>
    </Card>
  );
}
